﻿import './contextual.css';
import ContextualItem from './ContextualItem';
import { contextualCore } from './ContextualCore';

export default class Contextual {
    /**
     * Creates a new contextual menu
     * @param {object} opts options which build the menu e.g. position and items
     * @param {number} opts.width sets the width of the menu including children
     * @param {boolean} opts.isSticky sets how the menu apears, follow the mouse or sticky
     * @param {Array<ContextualItem>} opts.items sets the default items in the menu
     */
    constructor(opts) {
        this.owner = opts.owner;
        this.target = opts.target;
        this.event = opts.event;
        this.arrowClass = 'context-arrow';
        this.arrowSelector = '#context-arrow';
        contextualCore.CloseMenu(this.target, this.owner);

        this.position = opts.isSticky != null ? opts.isSticky : false;
        this.menuControl = contextualCore.CreateEl('<ul style="z-index: 100000;" class="contextualJs contextualMenu context-menu-list context-menu-root' + (this.target != null ? ' tooltip-inner-context' : '') + '">' + (this.target != null ? '<div id="' + this.arrowClass + '"></div><div class="context-close-wrapper"><span class="context-menu-title"><h5>' + generalResources.Menu + '</h5></span><span class="context-close-button" id="context-close">&times;</span></div>' : '') + '</ul>');
        this.menuControl.style.width = opts.width != null ? opts.width : 'auto';
        this.menuControl.style['min-width'] = opts.minWidth != null ? opts.minWidth : '250px';
        opts.items.forEach(i => {
            i.target = this.target;
            i.owner = this.owner
            let item = new ContextualItem(i);
            this.menuControl.appendChild(item.element);
        });

        if (this.target != null) {
            $(this.target)[0].appendChild(this.menuControl);
        } else {
            document.body.appendChild(this.menuControl);
        }

        if (this.event != undefined) {
            contextualCore.PositionMenu(this.position, this.event, this.menuControl, this.target);
        }

        if (this.target != null) {
            document.getElementById('context-close').addEventListener('click', (evt) => {
                $event.notify("contextMenuVisibilityChanged", { visible: false }, this);
                this.hide();
            });
        } else {
            document.onclick = (e) => {
                if (!e.target.classList.contains('contextualJs')) {
                    contextualCore.CloseMenu(this.target, this.owner);
                }
            }
        }
    }
    /**
     * Adds item to this contextual menu instance
     * @param {ContextualItem} item item to add to the contextual menu
     */
    add(item) {
        this.menuControl.appendChild(item.element);
    }
    /**
     * Makes this contextual menu visible
     */
    show() {
        event.stopPropagation()
        if (this.target != null) {
            $(this.target)[0].appendChild(this.menuControl);
        } else {
            document.body.appendChild(this.menuControl);
        }
        contextualCore.PositionMenu(this.position, event, this.menuControl, this.target);
    }
    /**
     * Hides this contextual menu
     */
    hide() {
        if (event != null) {
            event.stopPropagation();
        }

        contextualCore.CloseMenu(this.target, this.owner);
    }
    /**
     * Toggle visibility of menu
     */
    toggle() {
        event.stopPropagation()
        if (this.menuControl.parentElement != document.body) {
            if (this.target != null) {
                $(this.target)[0].appendChild(this.menuControl);
            } else {
                document.body.appendChild(this.menuControl);
            }
            contextualCore.PositionMenu(this.position, event, this.menuControl, this.target);
        } else {
            contextualCore.CloseMenu(this.target, this.owner);
        }
    }
}